// extracted by mini-css-extract-plugin
export default {"BuildingTill":"BuildingTill_BuildingTill__ULK+C","list":"BuildingTill_list__SG9C8"};